// @ts-ignore
/* eslint-disable */
import type { CustomRequestOptions } from '../customRequestOptions';
import { request } from '../axios/sdpShop';

/** 商户添加层级-批量 POST /mch/company/office/add/batch */
export async function officeAddBatch(
  body: APISdpShop.BatchAddOfficeRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpShop.GatewayDataResponseInt_>('/mch/company/office/add/batch', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 商户删除层级 前提：该层及其子层下无商户和操作员 POST /mch/company/office/del */
export async function companyOfficeDel(
  body: APISdpShop.DelOfficeRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpShop.GatewayResponse>('/mch/company/office/del', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 商户移动层级关系 其下的层级关系整体移动 POST /mch/company/office/move */
export async function companyOfficeMove(
  body: APISdpShop.MoveOfficeRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpShop.GatewayResponse>('/mch/company/office/move', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 商户修改层级名称 POST /mch/company/office/rename */
export async function companyOfficeRename(
  body: APISdpShop.RenameOfficeRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpShop.GatewayResponse>('/mch/company/office/rename', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询商户层级关系树 完整树；根层级名称是商户名称 POST /mch/company/office/tree/query */
export async function officeTreeQuery(options?: CustomRequestOptions) {
  return request<APISdpShop.GatewayDataResponseCompanyOfficeTreeVO_>(
    '/mch/company/office/tree/query',
    {
      method: 'POST',
      ...(options || {}),
    },
  );
}

/** 商户修改层级 修改所属父层级、层级名称等 POST /mch/company/office/update */
export async function companyOfficeUpdate(
  body: APISdpShop.UpdateOfficeRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpShop.GatewayResponse>('/mch/company/office/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询当前登录用户有权限的商户层级列表 只包含有权限的层级 POST /mch/currentuser/office/list/query */
export async function officeListQuery(
  body: APISdpShop.QueryOfficeListRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpShop.GatewayListResponse_>('/mch/currentuser/office/list/query', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询当前登录用户的商户层级关系树 包含有权限的层级、下级、无权限上级（为了构建正常树），不包含没有权限的邻居层级；根层级名称是商户名称 POST /mch/currentuser/office/tree/query */
export async function officeTreeQuery_2(options?: CustomRequestOptions) {
  return request<APISdpShop.GatewayDataResponseCompanyOfficeTreeVO_>(
    '/mch/currentuser/office/tree/query',
    {
      method: 'POST',
      ...(options || {}),
    },
  );
}

/** 查询商户员工层级 只包含是当前设置的层级，不包含有权限的子层级 POST /mch/operator/office/query */
export async function operatorOfficeQuery(
  body: APISdpShop.OperatorIdRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpShop.GatewayListResponse_>('/mch/operator/office/query', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 保存商户员工层级（全量覆盖） POST /mch/operator/office/save */
export async function operatorOfficeSave(
  body: APISdpShop.SaveMchOperatorOfficeRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpShop.GatewayResponse>('/mch/operator/office/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 指定子商户所在层级（添加、更新） 前提：子商户已绑定 POST /mch/submch/office/save */
export async function submchOfficeSave(
  body: APISdpShop.SaveSubMerchantOfficeRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpShop.GatewayResponse>('/mch/submch/office/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
